import { DateTime } from "luxon";

export function validateShippedDateRange(
  start: DateTime | null,
  end: DateTime | null
): string | undefined {
  if (!start || !end) return "Both a start and end ship date are required";
  if (!start.isValid || !end.isValid) return "Enter valid dates";
  if (start > end) return "Start date must be on or before end date";
  return undefined;
}
